/**
 * Flattens vi/en wordTypes → meanings into readable lines for the dict list table.
 * @param {Record<string, unknown>} record — row from GET /api/editor/dict-word?includeDefinitions=true
 * @returns {string[]}
 */
export function formatDictWordMeaningsLines(record) {
	if (!record || typeof record !== 'object') {
		return []
	}

	const lines = []

	const pushSide = (side, langLabel) => {
		if (!side || typeof side !== 'object') {
			return
		}
		const wordTypes = side.wordTypes
		if (!Array.isArray(wordTypes)) {
			return
		}
		wordTypes.forEach(wt => {
			const typeLabel = wt?.type || '—'
			const meanings = wt?.meanings
			if (!Array.isArray(meanings)) {
				return
			}
			meanings.forEach(m => {
				const def = (m?.definition || '').trim()
				if (def) {
					lines.push(`${langLabel} · ${typeLabel}: ${def}`)
				}
			})
		})
	}

	pushSide(record.en, 'EN')
	pushSide(record.vi, 'VI')

	return lines
}
